<template>
  <div id="app">
    <el-container>
      <el-header>
        <h1>Welcome to the ICE-MCI-Mod support page!</h1>
      </el-header>
      <el-container>
        <el-aside width="15%">
          <div class="sticky-scroll" :class="{ isScrollEnd: isScrollEnd }"  ref="sideHeight">
          <h2>Contents</h2>
          <ul>
            <li><a href="#layouts">Layouts of all the counterpart levels in SHQ and Minecraft</a></li>
            <li><a href="#moving">Trajectories on each Minecraft map</a></li>
            <li><a href="#source">Source code of the proposed system</a></li>
            <li><a href="#play">Play data of each participant</a></li>
            <li><a href="#demo">Demo video of our Minecraft mod’s gameplay</a></li>
          </ul>
        </div>
        </el-aside>
        <el-container>
          <el-main>
            <div><h21 id=layouts>Layouts of all the counterpart levels in SHQ and Minecraft</h21>
              <div>
                <h3>Level 1 / Level 1</h3>
                  <el-row>
                    <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/SHQ-1.PNG" alt="SHQ-1"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/MC-1.png" alt="MC-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                  </div>
                <div>
                  <h3>Level 2 / Level 2</h3>
                  <el-row>
                    <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/SHQ-2.PNG" alt="SHQ-1"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/MC-2.png" alt="MC-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Level 6 / Level 3</h3>
                  <el-row>
                    <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/SHQ-6.PNG" alt="SHQ-6"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/MC-6.png" alt="MC-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Level 8 / Level 4</h3>
                  <el-row>
                    <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/SHQ-8.PNG" alt="SHQ-8"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/MC-8.png" alt="MC-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Level 11 / Level 5</h3>
                  <el-row>
                    <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/SHQ-11.PNG" alt="SHQ-11"></div></el-col>
                    <el-col span="8"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/ICE_MCI_Mod/raw/wiki/images/MC-11.png" alt="MC-5"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"></div></el-col>
                  </el-row>
                </div>
              </div>
              <div>
                <h2  id=moving>Trajectories on each Minecraft map</h2><br>
                <div>
                  <h3>Participant 1</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/1-1.png" alt="1-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/1-2.png" alt="1-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/1-3.png" alt="1-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/1-4.png" alt="1-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/1-5.png" alt="1-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 2</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/2-1.png" alt="2-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/2-2.png" alt="2-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/2-3.png" alt="2-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/2-4.png" alt="2-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/2-5.png" alt="2-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 3</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/3-1.png" alt="3-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/3-2.png" alt="3-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/3-3.png" alt="3-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/3-4.png" alt="3-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/3-5.png" alt="3-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 4</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/4-1.png" alt="4-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/4-2.png" alt="4-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/4-3.png" alt="4-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/4-4.png" alt="4-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/4-5.png" alt="4-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 5</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/5-1.png" alt="5-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/5-2.png" alt="5-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/5-3.png" alt="5-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/5-4.png" alt="5-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/5-5.png" alt="5-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 6</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/6-1.png" alt="6-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/6-2.png" alt="6-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/6-3.png" alt="6-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/6-4.png" alt="6-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/6-5.png" alt="6-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 7</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/7-1.png" alt="7-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/7-2.png" alt="7-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/7-3.png" alt="7-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/7-4.png" alt="7-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/7-5.png" alt="7-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 8</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/8-1.png" alt="8-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/8-2.png" alt="8-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/8-3.png" alt="8-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/8-4.png" alt="8-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/8-5.png" alt="8-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 9</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/9-1.png" alt="9-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/9-2.png" alt="9-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/9-3.png" alt="9-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/9-4.png" alt="9-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/9-5.png" alt="9-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
                <div>
                  <h3>Participant 10</h3>
                  <el-row>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/10-1.png" alt="10-1"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/10-2.png" alt="10-2"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/10-3.png" alt="10-3"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/10-4.png" alt="10-4"></div></el-col>
                    <el-col span="4"><div class="grid-content bg-purple-light"><img src="https://github.com/it0sat0/mc-mci-supportpage/raw/main/subjects_images/10-5.png" alt="10-5"></div></el-col>
                    <el-col span="2"><div class="grid-content bg-purple"></div></el-col>
                  </el-row>
                </div>
              </div>
              <div>
                <h2 id=source>Source code of the proposed system</h2><br>
                <p>
                  This system consists of three java files and multiple recipes.<br>
                  All files can be found <a href="https://github.com/it0sat0/ICE-MCI-Mod/raw/main/MinecraftMod">here</a>
                </p>
              </div>
              <div>
                <h2 id=play>Play data of each participant</h2><br>
                <p>
                  All files can be found <a href="https://github.com/it0sat0/ICE-MCI-Mod/raw/main/data/minecraft_play_data">Minecraft's data</a><br>
                  All files can be found <a href="https://github.com/it0sat0/ICE-MCI-Mod/raw/main/data/SHQ_play_data">Sea Hero Quest's data</a>
                </p>
              </div>
              <div>
                <h2 id=demo>Demo video of our Minecraft mod’s gameplay</h2><br>
                <el-row>
                  <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                  <el-col span="16"><div class="grid-content bg-purple-light"><youtube :video-id="videoId"/></div></el-col>
                  <el-col span="4"><div class="grid-content bg-purple"></div></el-col>
                </el-row>
              </div>
            </el-main>
          <el-footer>2021.9.20 制作</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>










<script>
export default {
  name: 'app',
  components: {

  },
  data() {
    return {
      videoId: '4_XRjOF1wZw',
      isScrollEnd: false
    }
  },
  created() {
  this.handleScroll()
  },
  mounted() {
    // scroll位置の取得
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (!this.$refs.sideHeight) {
          return;
      }
      let sideHeight = this.$refs.sideHeight.clientHeight;
      let bodyHeight = document.body.clientHeight;
      let winHeight = window.innerHeight;
      if (winHeight < sideHeight) {
          if (
          bodyHeight - window.pageYOffset - winHeight <
          sideHeight - winHeight
          ) {
          this.isScrollEnd = true;
          } else {
          this.isScrollEnd = false;
          }
        } else {
            this.isScrollEnd = false;
        }
        return;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 120%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1{
  font-size: 250%;
}
h2{
  font-size: 200%;
  margin-top: 15%;
}
h21{
  font-size: 200%;
  margin-top: 3%;
}
h3{
  font-size: 180%;
  text-align: left;
  margin-left: 10%;
  margin-top: 3%;
}
img{
  width: 90%;
  text-align:center;
}


ul {
  padding: 0.5em 0.5em 0.5em 2em;/*ボックス内の余白*/
}

ul li {
  line-height: 1.5; /*文の行高*/
  padding: 0.5em 0; /*前後の文との余白*/
}

 .el-row {
    margin-bottom: 0px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    /*background: #99a9bf;*/
    background: #e5e9f2;
  }
  .bg-purple {
    /*background: #d3dce6;*/
    background: #e5e9f2;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
  }
  .row-bg {
    padding: 10px 0;
    /*background-color: #f9fafc;*/
    background-color: #e5e9f2;
  }


  .el-header {
    height: 20%;
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 1px;
  }

  .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    /*background-color: #E9EEF3;*/
    background-color: #e5e9f2;
    color: #333;
    text-align: center;
    line-height: 1.5; /*文の行高*/
    padding: 0.5em 0; /*前後の文との余白*/
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

  .sticky-scroll {
    width: 15%;
    position: fixed;
    &.isScrollEnd {
        bottom: 0;
        position: absolute;
        top: auto !important;
    }
}
</style>
